<template>
    <div>
        <b-card style="max-width: 40rem;" class="mb-2">
            <b-overlay :show="loading" rounded="sm">
                <b-card-title>
                    <h3 class="ml-3">Esqueceu a Senha?</h3>
                </b-card-title>
                <b-card-body>
                    <b-form @submit.prevent="enviarEmail">
                        <b-row>
                            <b-col sm="12">
                                <label for="type-email">Informe seu E-mail</label>
                                <b-form-input id="emailId" type="email" v-model="email" placeholder="email@dominio.com"
                                    required></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <b-button size="sm" variant="primary" type="submit">Enviar</b-button>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <small>Será enviado para seu e-mail as informações necessárias para redefinição de
                                    senha!</small>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card-body>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            loading: false
        }
    },
    methods: {
        enviarEmail() {
            const vm = this;
            vm.loading = true
            const data = {
                email: vm.email
            }
            axios.post('/password/remember', data)
                .then((response) => {
                    vm.$swal({
                        title: "Atenção",
                        text: "Foi enviado um email com instruções para redefinição de senha! Acesse seu email para continuar",
                        icon: "success",
                        footer: "Caso não encontre o email, verifique em sua caixa de spam!"
                    });
                }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    vm.loading = false
                })
        }
    }
}

</script>

<style>
button {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button:hover {
    background-color: #45a049;
    box-shadow: black;
}

span {
    color: red;
}


@media (max-width: 1000px) {
    .logo {
        display: none;
    }

    .title {
        text-align: justify;
        font-size: 18px;
    }

    .distribuidor {
        text-align: center;
        font-size: 20;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/util/Remember.vue